(function () {
    "use strict";

    angular.module("app").directive("otherRemarkFromInvolved", OtherRemarkFactory);

    function OtherRemarkFactory() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                allRemarks: "=",
                remarkName: "@",
                description: "@"
            },
            template: `
                <div ng-show="RemarkIsAdded()" class="row">
                    <div class="col-xs-12">
                        <h6>{{description}}</h6>
                        <p>{{remark.Remark}}</p>
                    </div>
                </div>
                `,
            link: function ($scope) {
                $scope.remarkAdded = false;

                if (!$scope.allRemarks && !$scope.remarkName)
                    return false;

                $scope.remark = _.find($scope.allRemarks, { SectionName: $scope.remarkName });

                if ($scope.remark && $scope.remark.Remark)
                    $scope.remarkAdded = true;

                $scope.RemarkIsAdded = function () {
                    if (!$scope.allRemarks && !$scope.remarkName)
                        return;
                    const remark = _.find($scope.allRemarks, { SectionName: $scope.remarkName });
                    return (remark && remark.Remark);
                };
            }
        };
    }
})();
